export const container = {
  display: "flex",
  flexDirection: "row",
};

export const modalContent = {
  display: "flex",
  flexDirection: "column",
  gap: "40px",
  backgroundColor: "white",
};

export const header = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
};

export const bladeImage =
  ({ bladeImage }) =>
  () => ({
    backgroundImage: `url(${bladeImage?.url})`,
    backgroundPosition: "50% 50%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: "96px",
    height: "50px",
    border: "1px solid #000000",
    borderRadius: "8px",
  });

export const headerImageContainer = {
  height: "0",
  width: "100%",

  position: "relative",
  mb: "20px",
  paddingTop: `${(84 / 600) * 100}%`,
};

export const headerImage = ({ bladeImageForPersonalisation }) => ({
  backgroundImage: `url(${bladeImageForPersonalisation.url})`,
  height: "100%",
  width: "100%",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "50% 0%",
  top: 0,
  left: 0,
  position: "absolute",
});

export const bladeTextContainer = ({ bladeType }) => {
  return {
    display: "flex",
    alignItems: "baseline",
    gap: "4px",
    position: "absolute",
    fontFamily: "diamanteef-bolditaregular",
    color: "grey1",
    flexDirection: "row",
    top: "50%",
    right: "18.5%",
    fontSize: "24px",

    ...(bladeType === "carbonLite"
      ? {
          flexDirection: "row-reverse",
          top: "74%",
          left: "39.5%",
          right: "auto",
          fontSize: "16px",
        }
      : {}),

    ...(bladeType === "flyTI"
      ? {
          color: "grey8",
        }
      : {}),
  };
};

export const defaultBladePersonalisationNameText = ({
  hasBladePlayerNumber,
}) => ({
  fontSize: "12px",
  paddingTop: hasBladePlayerNumber ? "0" : "12px",
});

export const carbonLiteBladePersonalisationNameText = ({
  hasBladePlayerNumber,
}) => ({
  fontSize: "12px",
  paddingTop: hasBladePlayerNumber ? "0" : "4px",
});

export const formRow = {
  display: "flex",
  flexDirection: "column",
  gap: "20px",
};

export const customizeBladePlayerNameContainer = ({ isMobile }) => ({
  ...formRow,
  flexDirection: isMobile ? "column" : "row",
});

export const field = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  gap: "20px",
  width: "100%",
};

export const label = {
  variant: "text.h5",
};

export const customizeBladePlayerName = {
  ...field,
  flexGrow: "1",
  flexShrink: "1",
};

export const customizeBladePlayerNumber = ({ isMobile }) => ({
  ...field,
  width: !isMobile && "140px",
  flexGrow: "0",
  flexShrink: "0",
});

export const customizeBladeNoPersonalization = {
  mt: "-20px",
};

export const customiseFeeNote = {
  backgroundColor: "grey9",
  padding: "10px",
  textAlign: "center",
  letterSpacing: "0.05em",
};

export const actions = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
};
